import { render, staticRenderFns } from "./BoxPlotChart.vue?vue&type=template&id=52e02c57&scoped=true"
import script from "./BoxPlotChart.vue?vue&type=script&lang=js"
export * from "./BoxPlotChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e02c57",
  null
  
)

export default component.exports